import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { StaticContentPlayCountApi, StaticContentPlayHistoryApi } from '../../apis'
import { AppState } from '../../reducers'
import { PlayCountService } from './base'

@Injectable()
export class StaticContentPlayCountService extends PlayCountService{
  constructor(protected api: StaticContentPlayCountApi) {
    super(api)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-count/static-content.ts